import styled from 'styled-components';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { TextContainerType } from './types';
import { faInfoCircle } from '@fortawesome/free-solid-svg-icons';

export const Container = styled.div`
	display: flex;
	flex-direction: row;
	align-items: center;
`;

export const TextContainer = styled.div<TextContainerType>`
	width: 100%;
	overflow: hidden;
	text-overflow: ellipsis;
	display: -webkit-box;
	-webkit-line-clamp: ${({ maxLines }) =>
		maxLines}; /* number of lines to show */
	line-clamp: ${({ maxLines }) => maxLines};
	-webkit-box-orient: vertical;
`;

export const InformationCircle = styled(FontAwesomeIcon).attrs({
	icon: faInfoCircle,
})<{ color?: string }>`
	margin-left: 10px;
	color: ${({ color }) => color ?? '#777'};
	height: 0.857rem;
	margin-bottom: 0px;
`;

export const CustomTooltip = styled.div`
	position: absolute;
	top: 50px;
	left: 50px;
	width: 100px;
	height: 100px;
	background-color: red;
`;
